import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine1SmProps extends ITextBoxProps {}

export const TextBoxMaxLine1Sm = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.FontSm,
  alignment = TextAligning.Left,
  maxLines = 1,
  ...rest
}: ITextBoxMaxLine1SmProps): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    maxLines={maxLines}
    {...rest}
  />
)
